// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

// The skin chosen in this browser, read once at startup before any style sheet is built.
const STORAGE_KEY = 'goffy.skin';

export function readStoredSkinName(): string | undefined {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return undefined;
    return window.localStorage.getItem(STORAGE_KEY)?.trim() || undefined;
  } catch {
    return undefined;
  }
}

export function writeStoredSkinName(name: string | null): void {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    if (name === null) window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, name);
  } catch (error) {
    console.warn('Could not store the skin choice', error);
  }
}
